module.exports = __webpack_public_path__ + "static/media/ThePowerOfNature.808c10b3.jpg";